import { render, staticRenderFns } from "./wf-radio-button-list-edit.vue?vue&type=template&id=58c442cc&scoped=true&"
import script from "./wf-radio-button-list-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-radio-button-list-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-radio-button-list-edit.vue?vue&type=style&index=0&id=58c442cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c442cc",
  null
  
)

export default component.exports